import { useEffect } from 'react';
import { useMuiMediaQuery } from '@/components/mui';
import { useUiIsMobile, useUiStoreActions } from '@/stores/uiStore';

function isTouchDevice() {
  // Check for touch points (modern browsers, including mobile and tablets)
  if (navigator.maxTouchPoints && navigator.maxTouchPoints > 0) {
    return true;
  }

  // Classic fallback: ontouchstart/touch event API
  if ('ontouchstart' in window) {
    return true;
  }

  // No touch detected
  return false;
}

export function useIsTouch() {
  const { setIsTouch } = useUiStoreActions();

  useEffect(() => {
    setIsTouch(isTouchDevice());
  }, [setIsTouch]);
}

/**
 * Custom hook that provides centralized mobile detection
 * Updates the UI store with the current mobile state and returns it
 * Uses MUI's standard 'md' breakpoint (900px) for consistency
 *
 * This should only be used in MobileProvider to initialize the state.
 * Other components should use useUiIsMobile() directly.
 */
export function useIsMobile() {
  const { setIsMobile } = useUiStoreActions();
  const isMobile = useUiIsMobile();

  // Use MUI's standard 'md' breakpoint for consistency across the app
  const isMobileQuery = useMuiMediaQuery('(max-width: 1000px)');

  // Update the store when the media query changes
  useEffect(() => {
    if (isMobileQuery !== isMobile) {
      setIsMobile(isMobileQuery);
    }
  }, [isMobileQuery, isMobile, setIsMobile]);
}
